export const ids = [
	'jobSetup',
	'scale',
	'frameAndOpening',
	'thickness',
	'externalFrame',
	'externalDimensions',
	'length',
	'height',
	'alignment',
] as const;
